import Section111ClaimantMatchPicker from "components/Section111ClaimantMatchPicker/Section111ClaimantMatchPicker";
import KaboodleModal from "components/Modals/KaboodleModal";
import type { Section111ClaimantMatch } from "services/claims-api";
import { useGetMatchingClaimsForClaimantQuery } from "services/claims-api";

type PrefillClaimantFromSection111ModalProps = {
  isOpen: boolean;
  onClose: () => void;
  claimantId: string | number | null | undefined;
  onSelect: (match: Section111ClaimantMatch) => void;
};

const PrefillClaimantFromSection111Modal = ({
  isOpen,
  onClose,
  claimantId,
  onSelect,
}: PrefillClaimantFromSection111ModalProps) => {
  const {
    data: matches = [],
    isFetching,
    isError,
  } = useGetMatchingClaimsForClaimantQuery(
    { claimantId: claimantId as string | number },
    { skip: !isOpen || !claimantId },
  );

  return (
    <KaboodleModal
      isOpen={isOpen}
      onClose={onClose}
      title="Prefill from Section 111"
    >
      <p>
        Select a matching Section 111 record to prefill the claimant information
        form. This will overwrite any field the record has data for.
      </p>
      <Section111ClaimantMatchPicker
        matches={matches}
        isFetching={isFetching}
        isError={isError}
        onSelect={onSelect}
        emptyMessage="No matching Section 111 records found for this claimant's SSN, or name and date of birth."
      />
    </KaboodleModal>
  );
};

export default PrefillClaimantFromSection111Modal;
